import { makeStyles, Theme } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) => ({
  cardMainParent: {
    float: "left",
    width: "100%",
  },
  cardMain: {
    marginBottom: "0px",
    paddingTop: "2px",
    width: "calc(100%)",
  },
  pageHeading: {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: theme.typography.fontWeightRegular,
    color: "#000",
  },
  tabCardContent: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    boxShadow: "none",
    borderRadius: "0px",
    padding: theme.spacing(2),
  },
  UserMainPanel: {
    width: "100%",
  },
  formRow: {
    width: "100%",
  },
  inlineHeading: {
    fontWeight: "bold",
    fontSize: "15px",
  },
  dateTime: { width: "100%", "& .MuiOutlinedInput-input": { padding: "10px" } },
  backdrop: {
    zIndex: theme.zIndex.modal + 1,
    color: "#fff",
  },
  sectionHeading: {
    marginTop: "10px",
    marginBottom: "10px",
    "& .MuiTypography-root": { fontWeight: "bold", fontSize: "15px" },
  },
}));
